export const getURLHostname = (url: string): string => {
  try {
    return url ? new URL(url).hostname : url;
  } catch (error) {
    return url;
  }
};
